// The backend returns naive ISO timestamps (no zone) from a UTC database clock.
// Without a zone marker `new Date()` would read them as browser-local time.
export function parseServerDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  let str = String(value).trim();
  let iso = str;
  // A trailing Z, numeric offset, GMT or UTC is already a zone marker
  if (!/(Z|GMT|UTC|[+-]\d{2}:?\d{2})$/i.test(iso)) {
    iso = iso.replace(' ', 'T') + 'Z';
  }
  let d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    // Safety net: let the engine try the original string (e.g. RFC 1123)
    d = new Date(str);
  }
  return Number.isNaN(d.getTime()) ? null : d;
}
